import { render, staticRenderFns } from "./FileMultiple.vue?vue&type=template&id=15fca808"
import script from "./FileMultiple.vue?vue&type=script&lang=js"
export * from "./FileMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports